import React, { useState } from 'react';
import { Card, Button, Modal, Form, Alert, Spinner, Container } from 'react-bootstrap';
import Navbar from "./navbar";
import Contact from "./Contact";
import Footer from "./Footer";
import { useUserPosts, createPost, deletePost } from '../hooks/usePosts';
import { useUserAuth } from '../Context/UserAuthContext';

const MyPosts = () => {
  const { posts, loading, error, refetch } = useUserPosts();
  const { user } = useUserAuth();
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [submitError, setSubmitError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleCreatePost = async (e) => {
    e.preventDefault();
    if (!title.trim() || !content.trim()) {
      setSubmitError('Please fill in all fields');
      return;
    }

    setSubmitting(true);
    setSubmitError('');

    const result = await createPost(
      user.uid,
      user.displayName || user.email,
      title,
      content
    );

    setSubmitting(false);

    if (result.success) {
      setShowModal(false);
      setTitle('');
      setContent('');
      refetch();
    } else {
      setSubmitError(result.error);
    }
  };

  const handleDeletePost = async (postId) => {
    if (window.confirm('Are you sure you want to delete this post?')) {
      const result = await deletePost(postId);
      if (result.success) {
        refetch();
      } else {
        alert('Error deleting post: ' + result.error);
      }
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <Navbar />
      <main className="main-content">
        <Container className="py-4">
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h1 style={{ margin: 0 }}>My Posts</h1>
            <Button variant="primary" onClick={() => setShowModal(true)}>
              Create New Post
            </Button>
          </div>

          {loading && (
            <div className="loading-container">
              <div className="loading-spinner"></div>
              <p className="loading-text">Loading posts...</p>
            </div>
          )}

          {error && (
            <Alert variant="danger">
              <strong>Error:</strong> {error}
            </Alert>
          )}

          {!loading && !error && posts.length === 0 && (
            <Alert variant="info">
              You haven't created any posts yet. Click "Create New Post" to get started!
            </Alert>
          )}

          <div className="row">
            {posts.map((post) => (
              <div key={post.id} className="col-md-6 col-lg-4 mb-4">
                <Card className="h-100">
                  <Card.Body className="d-flex flex-column">
                    <Card.Title>{post.title}</Card.Title>
                    <Card.Subtitle className="mb-3" style={{ color: '#8b7355', fontSize: '0.85rem' }}>
                      By {post.userName}<br />
                      {post.createdAt?.toDate().toLocaleDateString()}
                    </Card.Subtitle>
                    <Card.Text style={{ flex: 1 }}>{post.content}</Card.Text>
                    <Button
                      variant="danger"
                      size="sm"
                      onClick={() => handleDeletePost(post.id)}
                      className="mt-2"
                    >
                      Delete
                    </Button>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
        </Container>

        {/* Create Post Modal */}
        <Modal show={showModal} onHide={() => setShowModal(false)} centered>
          <Modal.Header closeButton>
            <Modal.Title>Create New Post</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {submitError && <Alert variant="danger">{submitError}</Alert>}
            <Form onSubmit={handleCreatePost}>
              <Form.Group className="mb-3">
                <Form.Label>Title</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter post title"
                  value={title}
                  onChange={(e) => setTitle(e.target.value)}
                  disabled={submitting}
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Label>Content</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={5}
                  placeholder="Enter post content"
                  value={content}
                  onChange={(e) => setContent(e.target.value)}
                  disabled={submitting}
                />
              </Form.Group>
              <Button variant="primary" type="submit" disabled={submitting}>
                {submitting ? 'Creating...' : 'Create Post'}
              </Button>
            </Form>
          </Modal.Body>
        </Modal>

        <Contact />
      </main>
      <Footer />
    </div>
  );
};

export default MyPosts;
